'use client';
import { useState, useEffect } from 'react';
import { formatCheckedAt } from '@/lib/utils';

interface RelativeTimeProps {
  dateStr: string;
}

export default function RelativeTime({ dateStr }: RelativeTimeProps) {
  // Start with static date string (matches server render)
  const [label, setLabel] = useState<string>(() => dateStr.split(' ')[0]);

  useEffect(() => {
    // After hydration, compute relative time on client only
    setLabel(formatCheckedAt(dateStr));
  }, [dateStr]);

  return <>{label}</>;
}
